import { render } from "./KOlMemberProfile.vue?vue&type=template&id=3d27e148&scoped=true"
import script from "./KOlMemberProfile.vue?vue&type=script&lang=js"
export * from "./KOlMemberProfile.vue?vue&type=script&lang=js"

import "./KOlMemberProfile.vue?vue&type=style&index=0&id=3d27e148&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d27e148"]])

export default __exports__